// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEnrollmentMatrixLiteDto
 */
export interface IEnrollmentMatrixLiteDto {
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentMatrixLiteDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentMatrixLiteDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentMatrixLiteDto
     */
    processing_rule_id?: number;
}

/**
 * Check if a given object implements the IEnrollmentMatrixLiteDto interface.
 */
export function instanceOfIEnrollmentMatrixLiteDto(value: object): value is IEnrollmentMatrixLiteDto {
    return true;
}

export function IEnrollmentMatrixLiteDtoFromJSON(json: any): IEnrollmentMatrixLiteDto {
    return IEnrollmentMatrixLiteDtoFromJSONTyped(json, false);
}

export function IEnrollmentMatrixLiteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEnrollmentMatrixLiteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'processing_rule_id': json['processing_rule_id'] == null ? undefined : json['processing_rule_id'],
    };
}

export function IEnrollmentMatrixLiteDtoToJSON(json: any): IEnrollmentMatrixLiteDto {
    return IEnrollmentMatrixLiteDtoToJSONTyped(json, false);
}

export function IEnrollmentMatrixLiteDtoToJSONTyped(value?: IEnrollmentMatrixLiteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'processing_rule_id': value['processing_rule_id'],
    };
}

